import React, { Component } from 'react';
import PropTypes from 'prop-types';
// import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import { FaFacebookSquare, FaTwitterSquare, FaInstagram } from 'react-icons/fa';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withSnackbar } from 'notistack';

import css from './FooterContainer.module.scss';
import organizationDuck from '../../../redux/modules/organizationDuck';
import railsContextDuck from '../../../redux/modules/railsContextDuck';
import handleServerError from '../../../lib/functions/handleServerError';

function mapStateToProps(store) {
  const { $$organizationStore, $$railsContextStore } = store;
  return {
    canEditOrganization: organizationDuck.selectors.canEditOrganization(
      $$organizationStore,
      $$railsContextStore
    ),
    isPreviewingWebsite: railsContextDuck.selectors.isPreviewingWebsite(
      $$railsContextStore
    ),
    display_contact_email: $$organizationStore.getIn([
      '$$organization',
      'display_contact_email',
    ]),
    display_contact_phone: $$organizationStore.getIn([
      '$$organization',
      'display_contact_phone',
    ]),
    facebook_url: $$organizationStore.getIn(['$$organization', 'facebook_url']),
    instagram_url: $$organizationStore.getIn([
      '$$organization',
      'instagram_url',
    ]),
    twitter_url: $$organizationStore.getIn(['$$organization', 'twitter_url']),
  };
}

class FooterContainer extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      facebook_url: props.facebook_url,
      instagram_url: props.instagram_url,
      twitter_url: props.twitter_url,
      display_contact_email: props.display_contact_email,
      display_contact_phone: props.display_contact_phone,
      facebook_url_error: null,
      twitter_url_error: null,
      instagram_url_error: null,
      display_contact_email_error: null,
      display_contact_phone_error: null,
    };

    this.organizationActions = bindActionCreators(
      organizationDuck.creators,
      this.props.dispatch
    );
  }

  handleOrgSave = (key, e) => {
    e.preventDefault();
    if (this.state[key] === this.props[key]) return;
    this.organizationActions
      .updateOrganization({ [key]: this.state[key] })
      .then((res) => {
        this.setState({ [`${key}_error`]: null, [key]: res.value.data[key] });
        this.props.enqueueSnackbar('Saved', { variant: 'success' });
      })
      .catch((error) => {
        const funcAcceptedKeys = () =>
          this.setState({ [`${key}_error`]: error.response.data[key] });
        handleServerError(
          error,
          key,
          this.props.enqueueSnackbar,
          funcAcceptedKeys
        );
      });
  };

  renderContact() {
    const {
      canEditOrganization,
      isPreviewingWebsite,
      display_contact_phone,
      display_contact_email,
    } = this.props;
    const isEditingOrganization = canEditOrganization && !isPreviewingWebsite;
    return isEditingOrganization ? (
      <Paper className={css.inputContainer}>
        <form onSubmit={(e) => this.handleOrgSave('display_contact_email', e)}>
          <TextField
            value={this.state.display_contact_email || ''}
            onChange={(e) =>
              this.setState({ display_contact_email: e.target.value })
            }
            label="Contact Email"
            onBlur={(e) => this.handleOrgSave('display_contact_email', e)}
            error={this.state.display_contact_email_error !== null}
            helperText={this.state.display_contact_email_error}
            fullWidth
          />
        </form>
        <form onSubmit={(e) => this.handleOrgSave('display_contact_phone', e)}>
          <TextField
            value={this.state.display_contact_phone || ''}
            onChange={(e) =>
              this.setState({ display_contact_phone: e.target.value })
            }
            label="Contact Phone Number"
            onBlur={(e) => this.handleOrgSave('display_contact_phone', e)}
            error={this.state.display_contact_phone_error !== null}
            helperText={this.state.display_contact_phone_error}
            fullWidth
          />
        </form>
      </Paper>
    ) : (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
        }}
      >
        {(display_contact_phone || display_contact_email) && (
          <div
            style={{
              fontFamily: 'anton, sans-serif',
              textTransform: 'uppercase',
            }}
          >
            {display_contact_email && (
              <div>
                <a
                  style={{ color: 'white', textDecoration: 'none' }}
                  href={`mailto:${display_contact_email}`}
                >
                  {display_contact_email}
                </a>
              </div>
            )}
            {display_contact_phone && (
              <div>
                <a
                  style={{ color: 'white', textDecoration: 'none' }}
                  href={`tel:${display_contact_phone}`}
                >
                  {display_contact_phone}
                </a>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  renderSocialIcons() {
    const {
      canEditOrganization,
      isPreviewingWebsite,
      facebook_url,
      instagram_url,
      twitter_url,
    } = this.props;
    const isEditingOrganization = canEditOrganization && !isPreviewingWebsite;
    return isEditingOrganization ? (
      <Paper className={css.inputContainer}>
        <form onSubmit={(e) => this.handleOrgSave('facebook_url', e)}>
          <TextField
            value={this.state.facebook_url || ''}
            onChange={(e) => this.setState({ facebook_url: e.target.value })}
            label="Facebook URL"
            onBlur={(e) => this.handleOrgSave('facebook_url', e)}
            error={this.state.facebook_url_error !== null}
            helperText={this.state.facebook_url_error}
            fullWidth
            // className={css.input}
          />
        </form>
        <form onSubmit={(e) => this.handleOrgSave('instagram_url', e)}>
          <TextField
            value={this.state.instagram_url || ''}
            onChange={(e) => this.setState({ instagram_url: e.target.value })}
            onBlur={(e) => this.handleOrgSave('instagram_url', e)}
            label="Instagram URL"
            error={this.state.instagram_url_error !== null}
            helperText={this.state.instagram_url_error}
            fullWidth
            // className={css.input}
          />
        </form>
        <form onSubmit={(e) => this.handleOrgSave('twitter_url', e)}>
          <TextField
            value={this.state.twitter_url || ''}
            onChange={(e) => this.setState({ twitter_url: e.target.value })}
            onBlur={(e) => this.handleOrgSave('twitter_url', e)}
            label="Twitter URL"
            error={this.state.twitter_url_error !== null}
            helperText={this.state.twitter_url_error}
            fullWidth
            // className={css.input}
          />
        </form>
      </Paper>
    ) : (
      <div>
        {facebook_url && (
          <a href={facebook_url}>
            <FaFacebookSquare
              style={{ fontSize: 36 }}
              className={css.facebookIcon}
            />
          </a>
        )}
        {instagram_url && (
          <a href={instagram_url}>
            <FaInstagram
              style={{ fontSize: 36 }}
              className={css.instagramIcon}
            />
          </a>
        )}
        {twitter_url && (
          <a href={twitter_url}>
            <FaTwitterSquare
              style={{ fontSize: 36 }}
              className={css.twitterIcon}
            />
          </a>
        )}
      </div>
    );
  }

  render() {
    return (
      <footer className={css.main}>
        <Grid container className={css.mainContainer} spacing={2}>
          <Grid item xs={12} sm={6}>
            {this.renderSocialIcons()}
          </Grid>
          <Grid item xs={12} sm={6}>
            {this.renderContact()}
          </Grid>
        </Grid>
      </footer>
    );
  }
}

FooterContainer.propTypes = {
  canEditOrganization: PropTypes.bool.isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
  isPreviewingWebsite: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  display_contact_email: PropTypes.string,
  display_contact_phone: PropTypes.string,
  facebook_url: PropTypes.string,
  instagram_url: PropTypes.string,
  twitter_url: PropTypes.string,
};
FooterContainer.defaultProps = {
  display_contact_email: '',
  display_contact_phone: '',
  facebook_url: '',
  instagram_url: '',
  twitter_url: '',
};

export default connect(mapStateToProps)(withSnackbar(FooterContainer));
